export default {
    timeFrameInput() {
        return {
            timeframe: {
                from: null,
                to: null
            },
            doComparision: false,
            compareTo: {
                from: null,
                to: null
            }
        }
    }
}